import React from 'react';
import { useParams } from 'react-router-dom';
import DemandUpdateForm from 'components/Demand/DemandUpdateForm/DemandUpdateForm';

const DemandUpdatePage: React.FC = () => {
  const { accountId = '', projectId = '', positionId = '', demandId = '' } = useParams();
  return <DemandUpdateForm accountId={accountId} projectId={projectId} positionId={positionId} demandId={demandId} />;
};

export default DemandUpdatePage;
